module.exports = __webpack_public_path__ + "img/fav-prod-1.5128f482.png";